export const SSE_TIMEOUT = 20000;
